/// <reference path="../../typings/tsd.d.ts" /> 
/// <reference path="../../typings/jquery/jquery.d.ts"/>
module warsApp.directives {

    export class CommentThread implements IDirective {
        public controller = ['$scope', 'commentService', '$compile', '$templateCache', '$http', 'userService', 'processDocumentService', CommentThreadController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/commentThread.html';
        public restrict: string = "E";

        public scope: any = {
            comment: '=',
            maxDepth: '=',
            currentDepth: "=",
            canRespond: "=",
            processId: "=",
            deleteText: "=",
            deleteButtonText: "=",
            showAvatar: "=",
            commentThreadSection: "=",
            allowCommentDateToBeSet: "=",
            commentDateLabel: "=",
            process: "=",
            documentConfiguration: "=",
            systemDocumentConfiguration: "=",
            commentThreadConfigUniqueId: "=",
            manageSectionUniqueId:"="
        };

        public link(scope: ICommentThreadScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: CommentThreadController): void {
            if (!scope.comment) return;
            if (angular.isArray(scope.comment.myCommentResponses)) {
                controller.$http.get('./app/views/_commentResponses.html', { cache: controller.$templateCache }).then(function(response: any) {
                    var html = controller.$compile(response.data)(scope);
                    element.append(html);
                }); 
            }
        }
    }

    export interface ICommentThreadScope extends ng.IScope {
        model: CommentThreadModel;
        comment: Wars.Domain.Model.Dtos.CommentThreadDto;
        maxDepth: number;
        currentDepth: number;
        canRespond: boolean;
        processId: string;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        deleteText: string;
        deleteButtonText: string;
        showAvatar: boolean;
        commentThreadSection: Wars.Domain.Model.Dtos.CommentThreadSectionDto;
        allowCommentDateToBeSet: boolean;
        commentDateLabel: string;
        documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        documentUpdated(model: models.FileUploadModel) : void;
        manageSectionUniqueId:string;
    }

    export class CommentThreadController implements IController {
        private scope: ICommentThreadScope;

        public $compile: ng.ICompileService;
        public $templateCache: ng.ITemplateCacheService;
        public $http: ng.IHttpService;

        constructor(
            $scope: ICommentThreadScope,
            commentService: services.CommentService,
            $compile: ng.ICompileService,
            $templateCache: ng.ITemplateCacheService,
            $http: ng.IHttpService,
            userService: services.UserService,
            processDocumentService: services.ProcessDocumentService) {
            this.scope = $scope;
            
            this.scope.model = new CommentThreadModel(
                this.scope.comment,
                this.scope.maxDepth,
                this.scope.currentDepth,
                commentService,
                this.scope.processId,
                this.scope.process,
                this.scope.deleteText,
                this.scope.deleteButtonText,
                this.scope.showAvatar,
                this.scope.commentThreadSection,
                userService,
                processDocumentService,
                this.scope.allowCommentDateToBeSet,
                this.scope.commentDateLabel,
                this.scope.canRespond,
                this.scope.manageSectionUniqueId);

            this.scope.documentUpdated = (model: models.FileUploadModel) => this.scope.model.documentUpdated(model);
            this.$compile = $compile;
            this.$templateCache = $templateCache;
            this.$http = $http;
        }
    }

    export class CommentThreadModel {
        public comment: Wars.Domain.Model.Dtos.CommentThreadDto;
        public maxDepth: number;
        public currentDepth: number;
        public currentChildDepth: number;
        public newResponse: string;
        public newResponseDocIds: string[];
        public addingResponse: boolean;
        public commentDate:any = null;
        
        private commentService: services.CommentService;

        constructor(
            comment: Wars.Domain.Model.Dtos.CommentThreadDto,
            maxDepth: number,
            currentDepth: number,
            commentService: services.CommentService,
            private processId: string,
            private process: Wars.Domain.Model.Dtos.ProcessDto,
            public deleteText: string,
            public deleteButtonText: string,
            public showAvatar: boolean,
            public commentThreadSection: Wars.Domain.Model.Dtos.CommentThreadSectionDto,
            private userService: services.UserService,
            private processDocumentService: services.ProcessDocumentService,
            public allowCommentDateToBeSet: boolean,
            public commentDateLabel: string,
            public canRespond?: boolean,
            private manageSectionUniqueId?:string)
        {
            this.comment = comment;
            this.maxDepth = maxDepth;
            this.currentDepth = currentDepth;
            this.currentChildDepth = currentDepth + 1;
            this.commentService = commentService;
        }

        public allowResponse(): boolean {
            if (!this.comment || !this.canRespond) return false;
            if (this.currentDepth >= (this.maxDepth - 1)  || this.comment.commentStatus === Wars.Domain.Model.Codes.Enums.CommentStatus.Deleted) {
                return false;
            }

            if (this.commentThreadSection) {
                return this.commentThreadSection.canComment;
            }

            return true;
        }

        public addResponse(): void {
            this.newResponse = undefined;
            this.newResponseDocIds = [];
            this.addingResponse = true;
        }

        public delete(): void {
            this.commentService.deleteComment(this.processId, this.comment.id).then(() => {
                this.comment.commentStatus = Wars.Domain.Model.Codes.Enums.CommentStatus.Deleted;
            });
        }

        public allowDelete(): boolean {
            if (this.comment && this.comment.commentStatus === Wars.Domain.Model.Codes.Enums.CommentStatus.Deleted)
                return false;

            if (this.commentThreadSection) {
                if (this.commentThreadSection.canDelete) {
                    return true;
                }

                if (this.commentThreadSection.canDeleteOwnComment &&
                    this.comment.lastUpdateUserId === this.userService.getCurrentUser().userId) {
                    return true;
                }
            }

            return false;
        }

        public saveResponse(): void {
            if (this.comment.commentType !== Wars.Domain.Model.Codes.Enums.CommentType.State) {

                var commentDto: Wars.Domain.Model.Dtos.CommentDto = {
                    comment: this.newResponse,
                    documentIds: this.newResponseDocIds,
                    processId: this.processId,
                    manageSectionUniqueId: this.manageSectionUniqueId,
                    commentDate: this.commentDate,
                    parentId: this.comment.id
                };

                this.commentService.createNewCommentThreadEntry(commentDto).then(
                    (commentThread) => {
                            this.comment.myCommentResponses.push(commentThread);
                            if (this.newResponseDocIds && this.process) {
                                this.processDocumentService.updateManageDocumentSections(this.process);
                            }
                        });
            } else {
                var commentDto: Wars.Domain.Model.Dtos.CommentDto = {
                    comment: this.newResponse,
                    documentIds: this.newResponseDocIds,
                    processId: this.processId,
                    manageSectionUniqueId: this.manageSectionUniqueId,
                    commentDate: this.commentDate,
                    parentId: this.comment.id
                };


                this.commentService.createNewUserActionCommentReply(commentDto).then(
                    (commentThread) => {
                        this.comment.myCommentResponses.push(commentThread);
                    });
            }

            this.newResponse = undefined;
            this.addingResponse = false;
        }

        public cancelResponse(): void {
            this.newResponse = undefined;
            this.addingResponse = false;
        }

        public documentUpdated(model: models.FileUploadModel): void {
            this.newResponseDocIds = Enumerable.from(model.documents).select(i => i.id).toArray();
        }
    }
}

warsApp.registerDirective('CommentThread', []);